// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"a618bfe0","878":"ceb0019b"}[chunkId] + ".chunk.js";
};